module.exports = __webpack_public_path__ + "img/icon-3.1d833552.png";